import React from "react";
import { Table, TableWrapper, Td, Th } from "./style";
import { useNavigate } from "react-router-dom";

const DataTable = ({ columns, data }) => {
  const navigate = useNavigate();
  return (
    <TableWrapper>
      <Table>
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <Th key={idx}>{col}</Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rIdx) => (
            <tr key={rIdx} onClick={() => navigate(row[row.length - 1])}>
              {row.slice(0, -1).map((cell, cIdx) => (
                <Td key={cIdx}>{cell}</Td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </TableWrapper>
  );
};

export default DataTable;
